@if (!disabled()) {
  <div class="editable-field-wrapper">
    <div cdkOverlayOrigin #origin="cdkOverlayOrigin">
      <div class="vitamui-input editable-field" [class.edit-mode]="editMode" (click)="enterEditMode()">
        <div class="editable-field-content">
          <label>{{ label() }}</label>
          <span class="editable-field-text-content">{{ control?.value }}</span>
          <div class="editable-field-control align">
            <input
              type="text"
              [formField]="formEmail.emailFirstPart"
              (input)="onEmailChange({ emailFirstPart: $any($event.target).value })"
            />
            <span class="layer">&#64;</span>
            <mat-form-field class="vitamui-mat-select vitamui-mat-select-mini">
              <mat-select
                [formField]="formEmail.domain"
                (selectionChange)="onEmailChange({ domain: $event.value })"
                panelClass="vitamui-mat-select"
                #select
              >
                @for (domainTmp of domains(); track domainTmp; let index = $index) {
                  <mat-option value="{{ domainTmp }}">
                    {{ domainTmp }}
                  </mat-option>
                }
              </mat-select>
              <div class="select-arrow">
                <i class="material-icons">keyboard_arrow_up</i>
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
            </mat-form-field>
          </div>
        </div>
        @if (!showSpinner && !editMode) {
          <i class="material-icons edit-icon">edit</i>
        }
        @if (showSpinner) {
          <div>
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </div>
        }
      </div>
    </div>
    <div class="vitamui-input-errors">
      <ng-content select="vitamui-common-field-error"></ng-content>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOpen]="editMode"
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayPositions]="positions"
    >
      <div class="editable-field-actions">
        <button type="button" class="editable-field-confirm" (click)="confirm()" [disabled]="!canConfirm">
          <i class="material-icons">check</i>
        </button>
        <button type="button" class="editable-field-cancel" (click)="cancel()"><i class="material-icons">clear</i></button>
      </div>
    </ng-template>
  </div>
}

@if (disabled()) {
  <div class="read-only-field">
    <label>{{ label() }}</label>
    <div>{{ control?.value }}</div>
  </div>
}
